import { Card } from "@wingspanhq/wingspan-api-sdk";
import {
  WSCard,
  WSElement,
  WSFlexBox,
  WSList,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { queriesCards, queriesInternalAccounts } from "@query";
import { selectorActiveBankingAccount } from "../../../../shared/selectors/selectorActiveBankingAccount";
import { selectorAccountBalance } from "../../../../shared/selectors/selectorAccountBalance";

export const CardBalance: React.FC<{ card: Card }> = ({ card }) => {
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();
  const internalAccount = queryInternalAccounts.data?.data?.find(
    selectorActiveBankingAccount
  );
  const queryInternalAccountBalance =
    queriesInternalAccounts.getInternalAccountBalance.useQuery(
      { internalAccountId: internalAccount?.id! },
      {
        enabled: !!internalAccount?.id
      }
    );

  const queryCardLimits = queriesCards.getCardLimits.useQuery({
    cardId: card.id
  });

  const balance = selectorAccountBalance(queryInternalAccountBalance.data);
  const availableBalance = balance.available;

  const availableLimit = Number(queryCardLimits.data?.availableLimit) || 1250;

  return (
    <WSCard>
      <WSList gap="XL">
        <WSElement>
          <WSText weight="medium" color="gray600">
            Available balance
          </WSText>
          <WSText.Heading1
            weight="book"
            color="gray500"
            shimmer={!queryInternalAccountBalance.isSuccess}
          >
            {formatMoney(availableBalance, balance.currency)}
          </WSText.Heading1>
        </WSElement>

        <WSList>
          <WSFlexBox.CenterY justify="space-between">
            <WSText.ParagraphSm color="gray500">
              Daily spend limit
            </WSText.ParagraphSm>

            <WSPill
              theme="neutral"
              text={formatMoney(availableLimit, balance.currency)}
            />
          </WSFlexBox.CenterY>

          <WSFlexBox.CenterY justify="space-between">
            <WSText.ParagraphSm color="gray500">
              Monthly spend limit
            </WSText.ParagraphSm>

            <WSPill theme="neutral" text="$10,000.00" />
          </WSFlexBox.CenterY>
        </WSList>
      </WSList>
    </WSCard>
  );
};
